import { render, staticRenderFns } from "./settlement-info.vue?vue&type=template&id=a27336e6"
import script from "./settlement-info.vue?vue&type=script&lang=js"
export * from "./settlement-info.vue?vue&type=script&lang=js"
import style0 from "./settlement-info.vue?vue&type=style&index=0&id=a27336e6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports